__turbopack_context__.v({
  "action": "ContentBlocks-module-scss-module__TX691q__action",
  "call-to-action": "ContentBlocks-module-scss-module__TX691q__call-to-action",
});
